"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const md5 = require("md5");
const jsonp_1 = require("./jsonp");
function shortenLink(srcUrl) {
    const url = '//buc.kim/dlink';
    let startTime = new Date().getTime() / 1000;
    let expireTime = startTime + 365 * 86400;
    let currentTime = startTime;
    expireTime = Math.floor(expireTime);
    startTime = Math.floor(startTime);
    currentTime = Math.floor(currentTime);
    const burl = window.btoa(srcUrl);
    let signStr = 'src_url=' + burl + '&start_time=' + startTime;
    signStr += '&current_time=' + currentTime + '&lilsivi3svPsd';
    const sign = md5(signStr);
    const params = {
        src_url: burl,
        start_time: startTime,
        expire_time: expireTime,
        current_time: currentTime,
        sign,
    };
    return new Promise((resolve, reject) => {
        const waitTimer = setTimeout(() => {
            reject('timeout');
        }, 2000);
        jsonp_1.default({
            url,
            data: params,
            callback: (res) => {
                clearTimeout(waitTimer);
                if (res.error) {
                    reject(res.error);
                }
                else {
                    resolve(res.short_url);
                }
            },
        });
    });
}
exports.default = shortenLink;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hvcnRMaW5rLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2hvcnRMaW5rLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsMkJBQTRCO0FBQzVCLG1DQUE0QjtBQUU1QixTQUF3QixXQUFXLENBQUMsTUFBYztJQUVoRCxNQUFNLEdBQUcsR0FBRyxpQkFBaUIsQ0FBQztJQUM5QixJQUFJLFNBQVMsR0FBRyxJQUFJLElBQUksRUFBRSxDQUFDLE9BQU8sRUFBRSxHQUFHLElBQUksQ0FBQztJQUM1QyxJQUFJLFVBQVUsR0FBRyxTQUFTLEdBQUcsR0FBRyxHQUFHLEtBQUssQ0FBQztJQUN6QyxJQUFJLFdBQVcsR0FBRyxTQUFTLENBQUM7SUFDNUIsVUFBVSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDcEMsU0FBUyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLENBQUM7SUFDbEMsV0FBVyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLENBQUM7SUFFdEMsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUVqQyxJQUFJLE9BQU8sR0FBRyxVQUFVLEdBQUcsSUFBSSxHQUFHLGNBQWMsR0FBRyxTQUFTLENBQUM7SUFDN0QsT0FBTyxJQUFJLGdCQUFnQixHQUFHLFdBQVcsR0FBRyxnQkFBZ0IsQ0FBQztJQUU3RCxNQUFNLElBQUksR0FBRyxHQUFHLENBQUMsT0FBTyxDQUFDLENBQUM7SUFFMUIsTUFBTSxNQUFNLEdBQUc7UUFDYixPQUFPLEVBQUUsSUFBSTtRQUNiLFVBQVUsRUFBRSxTQUFTO1FBQ3JCLFdBQVcsRUFBRSxVQUFVO1FBQ3ZCLFlBQVksRUFBRSxXQUFXO1FBQ3pCLElBQUk7S0FDTCxDQUFDO0lBRUYsT0FBTyxJQUFJLE9BQU8sQ0FBQyxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsRUFBRTtRQUNyQyxNQUFNLFNBQVMsR0FBRyxVQUFVLENBQUMsR0FBRyxFQUFFO1lBQ2hDLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUNwQixDQUFDLEVBQUUsSUFBSSxDQUFDLENBQUM7UUFDVCxlQUFLLENBQUM7WUFDSixHQUFHO1lBQ0gsSUFBSSxFQUFFLE1BQU07WUFDWixRQUFRLEVBQUUsQ0FBQyxHQUF3QyxFQUFFLEVBQUU7Z0JBQ3JELFlBQVksQ0FBQyxTQUFTLENBQUMsQ0FBQztnQkFDeEIsSUFBSSxHQUFHLENBQUMsS0FBSyxFQUFFO29CQUNiLE1BQU0sQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUM7aUJBQ25CO3FCQUFNO29CQUNMLE9BQU8sQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFDLENBQUM7aUJBQ3hCO1lBQ0gsQ0FBQztTQUNGLENBQUMsQ0FBQztJQUNMLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQztBQTFDRCw4QkEwQ0MifQ==